module.exports = __webpack_public_path__ + "assets/img/HH_Terra Hill_RGB_lr.cf5f9fe7.png";